import type { ThemeConfig } from 'antd';

// Antd v5+ is themed at runtime via ConfigProvider design tokens (LESS theming was
// removed). These globals mirror the brand values previously set in ant-variables.less
// (@primary-color, @error-color, font, etc.). Component-specific overrides currently
// remain in component LESS (bridged via root/styles/tokens.less) and will be migrated
// into the `components` block here incrementally — see MIGRATION_PLAN.md Phase 8.8.
const theme: ThemeConfig = {
  token: {
    colorPrimary: '#518db3', // @brand-blue
    colorError: '#db4437', // @brand-red
    colorSuccess: '#52c41a',
    // Antd derives link colour from colorInfo (its default #1677ff), not colorPrimary,
    // so plain <a> links rendered antd-blue. Antd v3 used @link-color: @brand-blue.
    colorLink: '#518db3', // @brand-blue
    colorLinkHover: '#6ba3c4', // lighten(@brand-blue)
    colorLinkActive: '#3f7197', // darken(@brand-blue)
    fontFamily: "'Open Sans', sans-serif",
    fontSize: 14,
    borderRadius: 4,
    colorText: 'rgba(0, 0, 0, 0.65)',
    colorTextSecondary: 'rgba(0, 0, 0, 0.45)',
  },
  components: {
    // Antd's default dark Layout header is #001529; the brand navy is
    // @brand-blue-dark (#0f1528). Restore the brand colour on the header.
    Layout: { headerBg: '#0f1528' },
    // Antd v3 sized form controls via @input-height-base: 41px (taller than the
    // 32px default). In v5/6 control height is a token, so restore 41px per input.
    Input: { controlHeight: 41 },
    InputNumber: { controlHeight: 41 },
    Select: { controlHeight: 41 },
    // Antd v3 used @btn-primary-bg: @brand-blue-dark — primary buttons were dark
    // navy while the global primary colour stayed @brand-blue. Reproduce that with a
    // Button-scoped primary colour so links/pagination keep brand-blue.
    Button: {
      // Match the 41px form-control height (antd v3 @input-height-base) so buttons
      // sitting next to inputs/selects line up instead of rendering at the 32px default.
      controlHeight: 41,
      colorPrimary: '#0f1528', // @brand-blue-dark
      colorPrimaryHover: '#1d2a45',
      colorPrimaryActive: '#080c18',
    },
  },
};

export default theme;
